import { mapState, mapGetters } from 'vuex'
export const timMixin = {
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'newMessageComing',
            'newMailComing',
            'onlineServices',
            'onlineServiceTel'
        ]),
        ...mapGetters([
            'customerServiceInfo',
            'currentUserProfile',
            'conversationList',
            'isTIM',
            'language',
            'name',
            'isLogin',
            'info',
            'subjectType',
            'exhibitionId',
            'exhibitorId',
            'config'
        ]),
    },
    methods: {
        async openChatDialog(flag) {
            if (flag) {
                if (this.$store.getters.isLogin) {
                    if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
                        await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
                    }
                }
            }

            if (this.isTIM) {
                this.$store.commit('setNewMessageStatus', false)
                await this.$store.commit('toogleShowList', true)
                await this.$store.commit('toogleChatDialog')
                console.log(this.$store)

                // 在线客服IM id
                let conversationID
                console.log('this.conversationList---->', this.conversationList)
                if (this.conversationList) {
                    conversationID = this.conversationList[0].conversationID
                }
                await this.$store.dispatch('checkoutConversation', conversationID)
                    .then(() => {
                        console.log('===========拉取会话列表成功===========')
                    }).catch(() => {
                        this.$message.warning('===========拉取会话列表成功失败===========')
                    })
                return
            }
        },
    }
}